import React from 'react';
import { Phone, ShieldAlert, CheckCircle2, Lock, ArrowRight, Star } from 'lucide-react';
function HeroStarRow() {
  return <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-95">
      {[0, 1, 2, 3, 4].map(i => <Star key={i} className="w-3.5 h-3.5 text-amber-500 fill-amber-500" data-id="element-96" />)}
    </span>;
}
export function Hero() {
  return <section className="bg-white pt-8 pb-12 md:pt-12 md:pb-16 px-4 sm:px-6 lg:px-8 border-b border-slate-100" data-id="element-97">
      <div className="max-w-7xl mx-auto" data-id="element-98">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start" data-id="element-99">
          {/* Left Column */}
          <div className="lg:col-span-7 flex flex-col" data-id="element-100">
            <div className="inline-flex items-center gap-2 bg-brand-redLight text-brand-red px-4 py-2 rounded-full text-sm font-semibold mb-4 w-fit border border-brand-redBorder" data-id="element-101">
              <span className="w-2 h-2 rounded-full bg-brand-red" data-id="element-102" />
              <span data-id="element-103">
                Broken Windshield Today? Same-Day Openings May Be Available
              </span>
            </div>

            {/* Social proof bar */}
            <div className="inline-flex flex-wrap items-center gap-x-3 gap-y-1.5 bg-white border border-slate-200 shadow-sm rounded-full px-4 py-2 mb-5 w-fit max-w-full" role="group" aria-label="Trust and social proof" data-id="element-104">
              <HeroStarRow data-id="element-105" />
              <span className="sr-only" data-id="element-106">5-star service.</span>
              <span className="text-xs sm:text-sm font-semibold text-slate-900" data-id="element-107">
                Drivers Across Southeast Michigan Trust Kosin's Glass
              </span>
              <span className="hidden sm:inline text-slate-300" aria-hidden="true" data-id="element-108">
                ·
              </span>
              <span className="text-xs sm:text-sm text-slate-600" data-id="element-109">
                Same-Day Openings May Be Available
              </span>
              <span className="hidden md:inline text-slate-300" aria-hidden="true" data-id="element-110">
                ·
              </span>
              <span className="hidden md:inline text-xs sm:text-sm text-slate-600" data-id="element-111">
                Family-Owned Since 2000
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 leading-[1.05] mb-6 tracking-tight" data-id="element-112">
              <span className="text-brand-red" data-id="element-113">
                Emergency Auto Glass Repair
              </span>{' '}
              <span className="text-slate-900" data-id="element-114">
                &amp; Windshield Replacement in
              </span>{' '}
              <span className="text-brand-red" data-id="element-115">Southeast Michigan</span>
            </h1>

            <p className="text-lg text-slate-600 mb-7 leading-relaxed max-w-2xl" data-id="element-116">
              Cracked windshield, shattered side window, broken rear glass or
              car door glass damage? Kosin's Glass provides urgent auto glass
              estimates, certified installation, insurance-claim help and
              same-day openings when available.
            </p>

            <ul className="space-y-3.5 mb-7" data-id="element-117">
              {['Windshield replacement, chip repair, side, door and rear window replacement', 'Same-day openings may be available depending on glass and schedule', 'Certified technicians using glass that meets or exceeds OEM standards', 'Insurance-claim help and lifetime vehicle glass workmanship warranty'].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-118">
                  <span className="shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 border-brand-red flex items-center justify-center" data-id="element-119">
                    <CheckCircle2 className="w-3 h-3 text-brand-red" strokeWidth={3} data-id="element-120" />
                  </span>
                  <span className="text-slate-700" data-id="element-121">{bullet}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-3 mb-5" data-id="element-122">
              <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-123">
                <Phone className="w-5 h-5" data-id="element-124" />
                Call 517-545-7772 Now
              </a>
              <a href="#quote-form" className="inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-50 text-slate-900 border border-slate-300 px-7 py-4 rounded-lg font-bold text-base transition-colors" data-id="element-125">
                Request Urgent Quote
                <ArrowRight className="w-4 h-4" data-id="element-126" />
              </a>
            </div>

            <p className="text-sm text-slate-500 mb-5" data-id="element-127">
              Serving Howell, Ann Arbor, Novi and Southeast Michigan.
            </p>

            <div className="bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 flex items-start gap-2.5 mb-3" data-id="element-128">
              <ShieldAlert className="w-4 h-4 text-slate-500 shrink-0 mt-0.5" data-id="element-129" />
              <p className="text-xs text-slate-600 leading-relaxed" data-id="element-130">
                If your visibility is blocked, glass is loose, or the vehicle
                feels unsafe to drive, do not continue driving. Call Kosin's
                Glass and the team will help you determine the safest next step.
              </p>
            </div>

            <div className="flex items-center gap-1.5 text-xs text-slate-500" data-id="element-131">
              <Lock className="w-3 h-3" data-id="element-132" />
              <span data-id="element-133">
                Your information is secure. Kosin's Glass will never share your
                details.
              </span>
            </div>
          </div>

          {/* Right Column: Form */}
          <div className="lg:col-span-5 w-full" id="quote-form" data-id="element-134">
            <div className="bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden" data-id="element-135">
              <div className="p-6 sm:p-8" data-id="element-136">
                <div className="inline-block bg-brand-red text-white px-3 py-1.5 text-xs font-bold uppercase tracking-wider mb-5 rounded" data-id="element-137">
                  Urgent Auto Glass Quote
                </div>
                <h2 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-138">
                  Request Emergency Auto Glass Help
                </h2>
                <p className="text-sm text-slate-600 leading-relaxed mb-6" data-id="element-139">
                  Submit your details and a Kosin's Glass team member will
                  contact you to confirm your vehicle, glass type, damage,
                  insurance information, location and today's availability.
                </p>

                <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-140">
                  <div data-id="element-141">
                    <label htmlFor="fullName" className="block text-sm font-semibold text-slate-900 mb-1.5" data-id="element-142">
                      Full Name
                    </label>
                    <input type="text" id="fullName" autoComplete="name" placeholder="John Smith" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-red/40 focus:border-brand-red outline-none transition-all text-slate-900 placeholder:text-slate-400" required data-id="element-143" />
                  </div>
                  <div data-id="element-144">
                    <label htmlFor="phone" className="block text-sm font-semibold text-slate-900 mb-1.5" data-id="element-145">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" autoComplete="tel" placeholder="(555) 123-4567" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-red/40 focus:border-brand-red outline-none transition-all text-slate-900 placeholder:text-slate-400" required data-id="element-146" />
                  </div>
                  <div data-id="element-147">
                    <label htmlFor="email" className="block text-sm font-semibold text-slate-900 mb-1.5" data-id="element-148">
                      Email Address
                    </label>
                    <input type="email" id="email" autoComplete="email" placeholder="john@email.com" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-brand-red/40 focus:border-brand-red outline-none transition-all text-slate-900 placeholder:text-slate-400" required data-id="element-149" />
                  </div>

                  <button type="submit" className="w-full bg-brand-red hover:bg-brand-redHover text-white font-bold uppercase tracking-wide text-sm py-4 rounded-md mt-2 transition-colors shadow-sm flex justify-center items-center gap-2" data-id="element-150">
                    Request My Urgent Quote
                    <ArrowRight className="w-4 h-4" data-id="element-151" />
                  </button>
                </form>

                <div className="mt-6 pt-5 border-t border-slate-100 text-center" data-id="element-152">
                  <p className="text-sm text-slate-600" data-id="element-153">
                    Prefer to call?{' '}
                    <a href="tel:517-545-7772" className="inline-flex items-center gap-1.5 text-slate-900 font-bold hover:text-brand-red" data-id="element-154">
                      <Phone className="w-4 h-4 text-brand-red" data-id="element-155" />
                      517-545-7772
                    </a>
                  </p>
                  <p className="text-xs text-slate-400 mt-2" data-id="element-156">
                    We respect your privacy. Your details are safe with us.
                  </p>
                </div>

                {/* Micro-testimonial */}
                <div className="mt-5 pt-5 border-t border-slate-100" data-id="element-157">
                  <div className="flex items-center gap-2 mb-2" data-id="element-158">
                    <HeroStarRow data-id="element-159" />
                    <span className="sr-only" data-id="element-160">5-star review.</span>
                    <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-161">
                      Verified Customer
                    </span>
                  </div>
                  <p className="text-sm italic text-slate-600 leading-relaxed" data-id="element-162">
                    "[Paste short real customer review here.]"
                  </p>
                  <p className="text-xs text-slate-500 mt-1.5" data-id="element-163">
                    — [Customer name], [City]
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}